import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import MainNav1 from "components/Header/MainNav1";
import GuestsInput from "components/HeroSearchForm2Mobile/GuestsInput";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";

import SectionOurFeatures from "components/SectionOurFeatures/SectionOurFeatures";
import SectionVRs from "./PageHome/SectionVRs";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import {
  getDestinationItemByLocation,
  getPlacesByCategory,
} from "services/api";
import { NAVIGATION_TABS } from "data/navigation";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NavigationItem from "shared/Navigation/NavigationItem";
import StayCard from "components/StayCard/StayCard";
import { addTravelingTo } from "store/actions/search";
import { useDispatch } from "react-redux";
import HeroSearchFormSmall from "components/HeroSearchForm/new/HeroSearchFormSmall";
import Seo from "components/Seo/Seo";
import LoadingModal from "components/LoadingModal/LoadingModal";

interface MonthlyTemperature {
  month: string;
  celsiusRange: string;
  fahrenheitRange: string;
  icon: string;
  image: string;
}

const PageDestinationItem: React.FC = () => {
  const { city, country } = useParams<{
    city?: string;
    country?: string;
  }>();

  const [destinationItem, setDestinationItem] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  // Data arrays for each category
  const [hotels, setHotels] = useState<any[]>([]);
  const [restaurants, setRestaurants] = useState<any[]>([]);
  const [activities, setActivities] = useState<any[]>([]);
  const [transport, setTransport] = useState<any[]>([]);
  const [extras, setExtras] = useState<any[]>([]);

  const [fullHotels, setFullHotels] = useState<any[]>([]);
  const [fullRestaurants, setFullRestaurants] = useState<any[]>([]);
  const [fullActivities, setFullActivities] = useState<any[]>([]);
  const [fullTransport, setFullTransport] = useState<any[]>([]);
  const [fullExtras, setFullExtras] = useState<any[]>([]);

  // "Show me more" state variables
  const [showMoreHotels, setShowMoreHotels] = useState(false);
  const [showMoreRestaurants, setShowMoreRestaurants] = useState(false);
  const [showMoreActivities, setShowMoreActivities] = useState(false);
  const [showMoreTransport, setShowMoreTransport] = useState(false);
  const [showMoreExtras, setShowMoreExtras] = useState(false);

  const [showDateModal, setShowDateModal] = useState(false);
  const [modalPathLink, setModalPathLink] = useState("");

  // New state: selected category for navigation
  const [selectedCategory, setSelectedCategory] = useState("hotels");
  const dispatch = useDispatch();

  // Navigation items for the accessible all in one section
  const navCategories = [
    { key: "hotels", label: "stays", icon: "la-bed" },
    { key: "activities", label: "experiences", icon: "la-camera-retro" },
    { key: "restaurants", label: "restaurants", icon: "la-utensils" },
    { key: "transport", label: "transfers", icon: "la-taxi" },
    { key: "extras", label: "extras", icon: "la-user-shield" },
  ];

  useEffect(() => {
    localStorage.setItem("origin", "destination/" + city + "/" + country);
    const fetchData = async () => {
      if (!city || !country) return;
      try {
        setLoading(true);

        // Fetch destination data and category arrays from API response
        const response = await getDestinationItemByLocation(city, country);
        if (response?.destinationItem) {
          setDestinationItem(response.destinationItem);
          dispatch(addTravelingTo(response.destinationItem));
        }
        if (response?.hotels) {
          setHotels(response.hotels);
          setFullHotels(response.hotels);
        }
        if (response?.restaurants) {
          setRestaurants(response.restaurants);
          setFullRestaurants(response.restaurants);
        }
        if (response?.experiences) {
          setActivities(response.experiences);
          setFullActivities(response.experiences);
        }
        if (response?.transportations) {
          let tmp_tr = response.transportations.map((item: any) => {
            let min_price = item.offers[0].price;
            item.offers.map((offer: any) => {
              if (offer.price < min_price) {
                min_price = offer.price;
              }
            });
            item.price = min_price;
            return item;
          });

          setTransport(tmp_tr);
          setFullTransport(tmp_tr);
        }
        if (response?.extras) {
          let tmp_ex = response.extras.map((item: any) => {
            let min_price = item.offers[0].price;
            item.offers.map((offer: any) => {
              if (offer.price < min_price) {
                min_price = offer.price;
              }
            });
            item.price = min_price;
            return item;
          });
          setExtras(tmp_ex);
          setFullExtras(tmp_ex);
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    console.log("PageDestinationItem", city, country);
    fetchData();
  }, [city, country]);
  useEffect(() => {
    localStorage.setItem("showBig", "false");
  }, []);

  // Handlers for "Show me more" buttons remain unchanged
  const handleShowMoreHotels = () => {
    setShowMoreHotels(true);
  };

  const handleShowMoreRestaurants = () => {
    setShowMoreRestaurants(true);
  };
  const handleShowMoreActivities = () => {
    setShowMoreActivities(true);
  };
  const handleShowMoreTransport = () => {
    setShowMoreTransport(true);
  };
  const handleShowMoreExtras = () => {
    setShowMoreExtras(true);
  };

  const handleShowDateModal = (pathLink: string) => {
    setShowDateModal(true);
    setModalPathLink(pathLink);
  };

  if (loading) {
    return (
      <div>
        <LoadingModal showModal={loading} />
      </div>
    );
  }

  if (!destinationItem) {
    return <div>Destination not found</div>;
  }

  return (
    <>
      {destinationItem.seoTitle && (
        <Seo
          title={destinationItem.seoTitle}
          description={destinationItem.seoDescription || ""}
          keywords={destinationItem.seoKeywords || ""}
          image={destinationItem.seoImage}
          name={`Orbito Travel – ${destinationItem.name}`}
          type="article"
        />
      )}
      <div
        className="container relative space-y-24 mb-24 lg:space-y-28 lg:mb-28"
        style={{ marginTop: -100 }}
      >
        <BgGlassmorphism />

        {/* Big cover image */}
        <div className="relative w-full rounded-lg overflow-hidden">
          <img
            src={destinationItem.coverImage}
            alt={destinationItem.name}
            className="w-full h-[600px] rounded-lg"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
            <a
              href="#accessibleAllInOne"
              className="px-6 py-3 bg-white text-black text-lg  font-semibold rounded-full"
            >
              Explore accessible {destinationItem.name}
            </a>
          </div>
        </div>

        {/* Full-width box with Title and Text */}
        <div className="listingSection__wrap">
          <h2 className="text-2xl font-semibold">{destinationItem.title}</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="text-neutral-6000 dark:text-neutral-300">
            <div dangerouslySetInnerHTML={{ __html: destinationItem.text }} />
            <div id="accessibleAllInOne" className="mb-10" />
          </div>
        </div>

        {/* Accessible All In One Section */}

        <div className="container my-10 rounded-lg p-8 bg-neutral-50 ">
          <h2 className="text-3xl font-semibold mb-6 ">
            Accessible {destinationItem.name}: all in one
          </h2>

          {/* New Navigation Bar */}
          <div className="flex space-x-6  first-step flex-row items-center justify-center">
            <ul
              className="first-step  self-center nc-Navigation flex flex-row items-center gap-4
      justify-between lg:flex lg:flex-wrap lg:items-center relative "
            >
              {navCategories.map((cat) => (
                <li key={cat.key} className="flex flex-col items-center mx-2">
                  <button
                    onClick={() => setSelectedCategory(cat.key)}
                    className={`inline-flex items-center text-xs xl:text-xs font-normal py-2 px-4 xl:px-5 rounded-full transition-colors ${
                      selectedCategory === cat.key
                        ? "bg-[#EF8733] text-white hover:bg-[#EF8733]"
                        : ""
                    }`}
                  >
                    <i className={`la ${cat.icon} text-4xl`}></i>
                  </button>
                  <div className="w-24 mt-1">
                    <p
                      className={`text-center ${
                        selectedCategory === cat.key
                          ? "font-bold text-[#EF8733]"
                          : "text-[#676767]"
                      }`}
                    >
                      {cat.label}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Conditionally render only the selected category */}
          {selectedCategory === "hotels" && (
            <>
              <p
                className="text-neutral-6000 dark:text-neutral-300"
                dangerouslySetInnerHTML={{ __html: destinationItem.hotelsText }}
              ></p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                {(showMoreHotels ? hotels : hotels.slice(0, 8)).map((stay) => (
                  // <div
                  //   key={hotel._id}
                  //   className="border p-3 rounded-lg shadow-sm dark:border-neutral-700"
                  // >
                  //   <img
                  //     src={hotel.cardImgs?.[0]?.url}
                  //     alt={hotel.name}
                  //     className="w-full h-48 object-cover rounded-md"
                  //   />
                  //   <h4 className="mt-2 text-lg font-semibold">{hotel.name}</h4>
                  //   <p className="text-sm text-neutral-500">
                  //     {hotel.overview?.substring(0, 100)}...
                  //   </p>
                  // </div>
                  <StayCard
                    onClickDestinations={() =>
                      handleShowDateModal("/where-to-stay/" + stay._id)
                    }
                    cardType={"HOTELS"}
                    key={stay._id}
                    data={stay}
                    className={""}
                    internalLink="/where-to-stay"
                    isOnCart={false}
                    isLoading={false}
                    destinations={true}
                  />
                ))}
              </div>
              {hotels.length > 8 && !showMoreHotels && (
                <div className="flex justify-center">
                  <button
                    onClick={handleShowMoreHotels}
                    className="px-4 py-2 bg-[#EF8733] center text-white rounded-full mt-4"
                  >
                    Show me more
                  </button>
                </div>
              )}
            </>
          )}

          {selectedCategory === "restaurants" && (
            <>
              <p
                className="text-neutral-6000 dark:text-neutral-300"
                dangerouslySetInnerHTML={{
                  __html: destinationItem.restaurantsText,
                }}
              ></p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                {(showMoreRestaurants
                  ? restaurants
                  : restaurants.slice(0, 8)
                ).map((stay) => (
                  // <div
                  //   key={restaurant._id}
                  //   className="border p-3 rounded-lg shadow-sm dark:border-neutral-700"
                  // >
                  //   <img
                  //     src={restaurant.cardImgs?.[0]?.url}
                  //     alt={restaurant.name}
                  //     className="w-full h-48 object-cover rounded-md"
                  //   />
                  //   <h4 className="mt-2 text-lg font-semibold">
                  //     {restaurant.name}
                  //   </h4>
                  //   <p className="text-sm text-neutral-500">
                  //     {restaurant.overview?.substring(0, 100)}...
                  //   </p>
                  // </div>
                  <StayCard
                    onClickDestinations={() =>
                      handleShowDateModal(
                        "/where-to-eat-and-drink-detail/" + stay._id
                      )
                    }
                    key={stay._id!}
                    data={stay}
                    internalLink="/where-to-eat-and-drink-detail"
                    priceStartingString=""
                    isOnCart={false}
                    isLoading={false}
                    destinations={true}
                  />
                ))}
              </div>
              {restaurants.length > 8 && !showMoreRestaurants && (
                <div className="flex justify-center">
                  <button
                    onClick={handleShowMoreRestaurants}
                    className="px-4 py-2 bg-[#EF8733] text-white rounded-full mt-4"
                  >
                    Show me more
                  </button>
                </div>
              )}
            </>
          )}

          {selectedCategory === "activities" && (
            <>
              <p
                className="text-neutral-6000 dark:text-neutral-300"
                dangerouslySetInnerHTML={{
                  __html: destinationItem.experiencesText,
                }}
              ></p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                {(showMoreActivities ? activities : activities.slice(0, 8)).map(
                  (stay) => (
                    //   <div
                    //     key={activity._id}
                    //     className="border p-3 rounded-lg shadow-sm dark:border-neutral-700"
                    //   >
                    //     <img
                    //       src={activity.cardImgs?.[0]?.url}
                    //       alt={activity.name}
                    //       className="w-full h-48 object-cover rounded-md"
                    //     />
                    //     <h4 className="mt-2 text-lg font-semibold">
                    //       {activity.name}
                    //     </h4>
                    //     <p className="text-sm text-neutral-500">
                    //       {activity.overview?.substring(0, 100)}...
                    //     </p>
                    //   </div>
                    <StayCard
                      onClickDestinations={() =>
                        handleShowDateModal("/what-to-do-detail/" + stay._id)
                      }
                      key={stay._id}
                      data={stay}
                      isLoading={false}
                      internalLink="/what-to-do-detail"
                      priceStartingString=""
                      isOnCart={false}
                      destinations={true}
                    />
                  )
                )}
              </div>
              {activities.length > 8 && !showMoreActivities && (
                <div className="flex justify-center">
                  <button
                    onClick={handleShowMoreActivities}
                    className="px-4 py-2 bg-[#EF8733] text-white rounded-full mt-4"
                  >
                    Show me more
                  </button>
                </div>
              )}
            </>
          )}

          {selectedCategory === "transport" && (
            <>
              <p
                className="text-neutral-6000 dark:text-neutral-300"
                dangerouslySetInnerHTML={{
                  __html: destinationItem.transfersText,
                }}
              ></p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                {(showMoreTransport ? transport : transport.slice(0, 8)).map(
                  (item) => (
                    <StayCard
                      onClickDestinations={() =>
                        handleShowDateModal(
                          "/how-to-move-around-detail/" + item._id
                        )
                      }
                      key={item._id}
                      data={item}
                      internalLink="/how-to-move-around-detail"
                      priceStartingString=""
                      isOnCart={false}
                      isLoading={false}
                      destinations={true}
                      address={item.city + ", " + item.country}
                    />
                  )
                )}
              </div>
              {transport.length > 8 && !showMoreTransport && (
                <div className="flex justify-center">
                  <button
                    onClick={handleShowMoreTransport}
                    className="px-4 py-2 bg-[#EF8733] text-white rounded-full mt-4"
                  >
                    Show me more
                  </button>
                </div>
              )}
            </>
          )}

          {selectedCategory === "extras" && (
            <>
              <p
                className="text-neutral-6000 dark:text-neutral-300"
                dangerouslySetInnerHTML={{ __html: destinationItem.extrasText }}
              ></p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                {(showMoreExtras ? extras : extras.slice(0, 8)).map((item) => (
                  // <div
                  //   key={extra._id}
                  //   className="border p-3 rounded-lg shadow-sm dark:border-neutral-700"
                  // >
                  //   <img
                  //     src={extra.cardImgs?.[0]?.url}
                  //     alt={extra.name}
                  //     className="w-full h-48 object-cover rounded-md"
                  //   />
                  //   <h4 className="mt-2 text-lg font-semibold">{extra.name}</h4>
                  //   <p className="text-sm text-neutral-500">
                  //     {extra.overview?.substring(0, 100)}...
                  //   </p>
                  // </div>
                  <StayCard
                    onClickDestinations={() =>
                      handleShowDateModal("/what-is-extra-detail/" + item._id)
                    }
                    key={item._id}
                    data={item}
                    internalLink="/what-is-extra-detail"
                    priceStartingString=""
                    isOnCart={false}
                    isLoading={false}
                    destinations={true}
                    address={item.city + ", " + item.country}
                  />
                ))}
              </div>
              {extras.length > 8 && !showMoreExtras && (
                <div className="flex justify-center">
                  <button
                    onClick={handleShowMoreExtras}
                    className="px-4 py-2 bg-[#EF8733]  text-white rounded-full mt-4"
                  >
                    Show me more
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* Average monthly temperature */}
        <div className=" my-10">
          <h2 className="text-3xl font-semibold mb-6">
            Average monthly temperature
          </h2>
          <div className="grid grid-cols-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-4 gap-6">
            {destinationItem.monthlyTemperatures?.map(
              (temp: MonthlyTemperature, index: number) => (
                <div
                  key={index}
                  className="border p-3 rounded-lg flex flex-row items-center"
                >
                  <img
                    src={temp.image}
                    alt={temp.month}
                    className="w-16 h-16 object-cover rounded-full mb-2"
                  />
                  <i
                    className={`la la-${temp.icon} text-7xl mr-3 text-gray-500`}
                  ></i>
                  <div className="flex flex-col">
                    {/* <p className="font-semibold">{temp.month}</p> */}
                    <p className="text-md text-gray-500">
                      {" "}
                      {temp.celsiusRange} °C
                    </p>
                    <p className="text-md text-gray-500">
                      {temp.fahrenheitRange} °F
                    </p>
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        {/* Other sections remain unchanged */}
        <div className=" my-10">
          <SectionOurFeatures />
        </div>
        <div className=" my-10">
          <SectionVRs />
        </div>
        <div className=" my-10">
          <SectionSubscribe2 />
        </div>
        <div className=" my-10">
          <SectionSliderNewCategories
            heading="Awards"
            subHeading=""
            categoryCardType="card5"
            itemPerRow={3}
            sliderStyle="style2"
            uniqueClassName="ListingCarDetailPage"
          />
        </div>
      </div>
      {showDateModal && (
        <HeroSearchFormSmall
          onClose={() => setShowDateModal(false)}
          pathLink={modalPathLink}
        />
      )}
    </>
  );
};

export default PageDestinationItem;
